<form novalidate #updatePasswordForm="ngForm" (ngSubmit)="submit(updatePasswordForm)">
  <div class="modal-body">
    <div class="form-group row">
      <label class="col-md-12 col-form-label">現在のパスワード</label>
      <div class="col-md-12 form-group">
        <input [disabled]="busy || blocked" type="password" class="form-control" [(ngModel)]="nowPassword" name="nowPassword" required autocomplete="off" placeholder="現在のパスワード">
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-12 col-form-label">新しいパスワード</label>
      <div class="col-md-12 form-group">
        <input [disabled]="busy || blocked" type="password" class="form-control" [(ngModel)]="newPassword1" name="newPassword1" minlength="8" sfMaxLength="16" required autocomplete="off" placeholder="新しいパスワード: 8～16文字">
      </div>
      <label class="col-md-12 col-form-label">新しいパスワードの確認</label>
      <div class="col-md-12">
        <input [disabled]="busy || blocked" type="password" class="form-control" [(ngModel)]="newPassword2" name="newPassword2" minlength="8" sfMaxLength="16" required autocomplete="off" placeholder="新しいパスワードの確認">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn bg-close text-white" type="button" (click)="cancel.emit()" [disabled]="busy"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
    <button class="btn btn-success" type="submit" [disabled]="updatePasswordForm.invalid || updatePasswordForm.pending || busy || blocked"><i class="fa s-icon-save"></i>&nbsp;保存</button>
  </div>
</form>
